// import React from "react";
// import PropTypes from "prop-types";
// import { connect } from "react-redux";
// import { Row, Col, Button, Dropdown } from "react-bootstrap";
// import RangeCredit from "../../components/Game/Addons";
// import { gameCoin } from "actions/gameCoin";
// import { setWallet } from "actions/gameWallet";
// import storage from "utils/Storage";
// import C from 'utils/Constant';
// import { Event, __, forceSatoshiFormat, isValidNumber, wait, sendNotfication } from 'utils/Helper';

// class Bet extends React.Component {
//     _isMounted = false;
//     constructor(props) {
//         super(props);
//         this.state = {
//             engine: this.props.engine,
//             isLogged: storage.getKey("logged") !== null ? true : false,
//             amount: forceSatoshiFormat(storage.getKey('lam') ? storage.getKey('lam') : .00000010),
//             mine: 3,
//             profit: 0,
//             cashout: false,
//             inputDisabled: false,
//             buttonText: "BET",
//             btnType: "btn-bet",
//             started: false
//         };
//         this.handleInputChange = this.handleInputChange.bind(this);
//         this.handleBet = this.handleBet.bind(this);
//     }

//     componentDidMount() {
//         let { engine } = this.state;
//         this._isMounted = true;

//         this.props.gameCoin();
//         engine.on(C.PLAY_MINE, () => this.play());
//         engine.on(C.CLICKED_MINE, (data) => this.clicked(data));
//         engine.on(C.CASHOUT_MINE, () => this.end());
//         engine.on(C.BUSTED_MINE, () => this.busted());
//         engine.on(C.ERORR_MINE, (data) => this.error(data));
//         engine.on("stop_playing", () => this.stopManual());
//     }

//     componentWillUnmount() {
//         let { engine } = this.state;
//         engine.init = false;
//         this._isMounted = false;
//     }

//     stopManual() {
//         this.setState({ started: false, buttonText: 'BET', inputDisabled: false });
//     }

//     busted = () => {
//         if(this._isMounted)
//         {
//             this.setState({
//                 inputDisabled: true,
//                 inputDisabled2: true
//             });

//             return this.end();
//         }
//     }

//     end() {
//         if(this._isMounted)
//         {
//             wait(2200).then(() => {
//                 this.setState({
//                     profit: 0,
//                     cashout: false,
//                     buttonText: "BET",
//                     btnType: "btn-bet",
//                     inputDisabled: false,
//                     inputDisabled2: false,
//                     started: false
//                 });
//             });
//         }
//     }

//     play() {
//         if(this._isMounted){
//             this.setState({
//                 started: true,
//                 inputDisabled: true,
//                 inputDisabled2: true,
//                 buttonText: "Game is Started!",
//             });
//         }
//     }

//     clicked(data) {
//         if(this._isMounted){
//             let { profit, coin } = data;
//             let calc = __.toNumber(profit) + __.toNumber(this.state.profit);
//             let win = forceSatoshiFormat(calc);

//             this.setState({
//                 inputDisabled: false,
//                 btnType: "btn-bet-success",
//                 buttonText: win + " " + coin + " CashOut",
//                 cashout: true,
//                 profit: win
//             });
//         }
//     }

//     error(data) {
//         if(this._isMounted){
//             sendNotfication(data.message, 'info', 'top-center');

//             if(data.code === 'credit')
//                 this.props.setWallet(true, data.uid);

//             this.setState({ inputDisabled: false, started: false });
//         }
//     }

//     handleBet(e) {
//         e.preventDefault();
//         let { isLogged, amount } = this.state;

//        // Check User
//         if(!isLogged){
//            return Event.emit('showAuthModal', true);
//         }

//         if(parseFloat(amount) <= 0){
//             this.setState({ amount: forceSatoshiFormat(0.00000010) });
//         }
//         else {
//             amount = Math.min(parseFloat(storage.getKey('credit')), parseFloat(amount));
//             this.setState({ amount: forceSatoshiFormat(amount) });
//         }

//         this.setState({ inputDisabled: true});
//         this.placeBet();
//     }

//     placeBet() {
//         if(this._isMounted){
//             let { mine, amount, engine, cashout, profit } = this.state;
//             engine.init = true;

//             if (cashout) {
//                 engine.profit = profit;
//                 engine.cashout();
//                 return;
//             }

//             wait(100).then(() => {
//                 engine.amount = amount;
//                 engine.mine = mine;
//                 engine.coin = this.props.coin;
//                 engine.start();
//             });
//         }
//     }

//     handleInputChange(event) {
//         let target = event.target;
//         let value = target.value;

//         if (target.name === "amount") {
//             this.setState({amount:value})
//             if (!isValidNumber(value)) return;
//         }

//         if(target.name === 'amount'){
//             storage.setKey('lam', value);
//         }

//         this.setState({ [target.name]: value });
//     }

//     handleInputMines = (value) => {
//         if(!this.state.started)
//             this.setState({ mine: value});
//     };

//     setAmount = (val) => {
//         var am = forceSatoshiFormat(val);
//         this.setState({ amount: am });
//         storage.setKey('lam', am );
//     }

//     render() {
//         let { inputDisabled, inputDisabled2, mine } = this.state;
//         return (
//             <>
//                 <form
//                     className="w-100"
//                     onSubmit={(e) => {
//                         this.handleBet(e);
//                     }}

//                 >
//                     <Row>
//                         <Col xl={6} md={7} sm={12}>
//                             <div className={"form-group mb-1 bet-input"}>
//                                 <div className="input-group">
//                                     <div className="input-group-append">
//                                         <span className="input-group-text">
//                                           <img
//                                               src={"/assets/images/" + this.props.coin + ".png"}
//                                               className={"mini-coin-7"}
//                                               alt=""
//                                           />
//                                           BET
//                                         </span>
//                                     </div>
//                                     <input
//                                         disabled={inputDisabled2}
//                                         type="text"
//                                         className="form-control text-left"
//                                         id="amount"
//                                         name="amount"
//                                         placeholder="Enter Bet Amount"
//                                         value={this.state.amount}
//                                         autoComplete={"off"}
//                                         onKeyUp={this.handleInputChange}
//                                         onChange={this.handleInputChange}
//                                     />
//                                     <div className="input-group-append">
//                                         <RangeCredit set={this.setAmount} />
//                                     </div>
//                                 </div>
//                             </div>
//                         </Col>
//                         <Col xl={6} md={5} sm={12}>
//                             <div className={"form-group mb-1"}>
//                                 <div className="input-group fw">
//                                     <div className="input-group-append">
//                                         <span className="input-group-text">
//                                             <i className="mdi mdi-bomb font-25 text-danger mr-1" />
//                                             NUMBER OF MINES
//                                         </span>
//                                     </div>
//                                     <Dropdown drop={''} className={"drop-select btn-block"}>
//                                         <Dropdown.Toggle split variant="" className={"py-0 mt-0"}>
//                                               <span className="text-muted text-center">
//                                                 <i className={"mdi mdi-chevron-down mr-1"} /> {mine}
//                                               </span>
//                                         </Dropdown.Toggle>
//                                         <Dropdown.Menu
//                                             disabled={inputDisabled2}
//                                             className={"dopdown-menu-bottom " + inputDisabled2}
//                                         >
//                                             <Dropdown.Item
//                                                 onClick={(e) => this.handleInputMines(3)}
//                                                 className={"animated fadeIn"}
//                                             >

//                                                 3
//                                             </Dropdown.Item>
//                                             <Dropdown.Item
//                                                 onClick={(e) => this.handleInputMines(5)}
//                                                 className={"animated fadeIn"}
//                                             >

//                                                 5
//                                             </Dropdown.Item>
//                                             <Dropdown.Item
//                                                 onClick={(e) => this.handleInputMines(10)}
//                                                 className={"animated fadeIn"}
//                                             >

//                                                 10
//                                             </Dropdown.Item>
//                                             <Dropdown.Item
//                                                 onClick={(e) => this.handleInputMines(24)}
//                                                 className={"animated fadeIn"}
//                                             >

//                                                 24
//                                             </Dropdown.Item>
//                                         </Dropdown.Menu>
//                                     </Dropdown>
//                                 </div>
//                             </div>
//                         </Col>
//                     </Row>
//                     <Row>
//                         <Col md={5} sm={12} className=" m-auto">
//                             <div className={"form-group rev mt-2 mb-0"}>
//                                 <Button
//                                     variant={"btn btn-md btn-block mt-2 " + this.state.btnType}
//                                     disabled={inputDisabled}
//                                     type="submit"
//                                 >
//                                     {this.state.buttonText}
//                                 </Button>
//                             </div>
//                         </Col>
//                     </Row>
//                 </form>
//             </>
//         );
//     }
// }

// Bet.propTypes = {
//     coin: PropTypes.string.isRequired,
//     credit: PropTypes.string
// };

// const mapStateToProps = (state) => ({
//     coin: state.items.coin,
//     credit: state.items.credit
// });

// export default connect(mapStateToProps, {
//     gameCoin,
//     setWallet
// })(Bet);

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Row, Col, Button, Dropdown } from "react-bootstrap";
import RangeCredit from "../../components/Game/Addons";
import { gameCoin } from "actions/gameCoin";
import { setWallet } from "actions/gameWallet";
import storage from "utils/Storage";
import C from 'utils/Constant';
import { FiAlertCircle } from "react-icons/fi";
import {
  Event,
  __,
  forceSatoshiFormat,
  isValidNumber,
  wait,
  sendNotfication,
} from 'utils/Helper';
import { border } from "@mui/system";

class Bet extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      engine: this.props.engine,
      isLogged: storage.getKey("logged") !== null ? true : false,
      amount: forceSatoshiFormat(
        storage.getKey("lam") ? storage.getKey("lam") : 50.00
      ),
      mine: 3,
      profit: 0,
      cashout: false,
      inputDisabled: false,
      buttonText: "BET",
      btnType: "btn-bet",
      started: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleBet = this.handleBet.bind(this);
  }

  componentDidMount() {
    let { engine } = this.state;
    this._isMounted = true;

    this.props.gameCoin();
    engine.on(C.PLAY_MINE, () => this.play());
    engine.on(C.CLICKED_MINE, (data) => this.clicked(data));
    engine.on(C.CASHOUT_MINE, () => this.end());
    engine.on(C.BUSTED_MINE, () => this.busted());
    engine.on(C.ERORR_MINE, (data) => this.error(data));
    engine.on("stop_playing", () => this.stopManual());
  }

  componentWillUnmount() {
    let { engine } = this.state;
    engine.init = false;
    this._isMounted = false;
  }

  stopManual() {
    this.setState({ started: false, buttonText: "BET", inputDisabled: false });
  }

  busted = () => {
    if (this._isMounted) {
      this.setState({
        inputDisabled: true,
        inputDisabled2: true,
      });

      return this.end();
    }
  };

  end() {
    if (this._isMounted) {
      wait(2200).then(() => {
        this.setState({
          profit: 0,
          cashout: false,
          buttonText: "BET",
          btnType: "btn-bet",
          inputDisabled: false,
          inputDisabled2: false,
          started: false,
        });
      });
    }
  }

  play() {
    if (this._isMounted) {
      this.setState({
        started: true,
        inputDisabled: true,
        inputDisabled2: true,
        buttonText: "Game is Started!",
      });
    }
  }

  clicked(data) {
    if (this._isMounted) {
      let { profit, coin } = data;
      let calc = __.toNumber(profit) + __.toNumber(this.state.profit);
      let win = forceSatoshiFormat(calc);

      this.setState({
        inputDisabled: false,
        btnType: "btn-bet-success",
        buttonText: win + " " + coin + " CashOut",
        cashout: true,
        profit: win,
      });
    }
  }

  error(data) {
    if (this._isMounted) {
      sendNotfication(data.message, "info", "top-center");

      if (data.code === "credit") this.props.setWallet(true, data.uid);

      this.setState({ inputDisabled: false, started: false });
    }
  }

  handleBet(e) {
    e.preventDefault();
    let { isLogged, amount } = this.state;

    // Check User
    if (!isLogged) {
      return Event.emit("showAuthModal", true);
    }

    if (parseFloat(amount) <= 0) {
      this.setState({ amount: forceSatoshiFormat(50.00) });
    } else {
      amount = Math.min(
        parseFloat(storage.getKey("credit")),
        parseFloat(amount)
      );
      this.setState({ amount: forceSatoshiFormat(amount) });
    }

    this.setState({ inputDisabled: true });
    this.placeBet();
  }

  placeBet() {
    if (this._isMounted) {
      let { mine, amount, engine, cashout, profit } = this.state;
      engine.init = true;

      if (cashout) {
        engine.profit = profit;
        engine.cashout();
        return;
      }

      wait(100).then(() => {
        engine.amount = amount;
        engine.mine = mine;
        engine.coin = this.props.coin;
        engine.start();
      });
    }
  }

  handleInputChange(event) {
    let target = event.target;
    let value = target.value;

    if (target.name === "amount") {
      this.setState({ amount: value });
      if (!isValidNumber(value)) return;
    }

    if (target.name === "amount") {
      storage.setKey("lam", value);
    }

    this.setState({ [target.name]: value });
  }

  handleInputMines = (value) => {
    if (!this.state.started) this.setState({ mine: value });
  };

  setAmount = (val) => {
    var am = forceSatoshiFormat(val);
    this.setState({ amount: am });
    storage.setKey("lam", am);
  };

  render() {
    let { inputDisabled, inputDisabled2, mine } = this.state;
    return (
      <>
        <form
          className="w-100"
          onSubmit={(e) => {
            this.handleBet(e);
          }}
        >
          <Row>
            {/* <Col xl={12} md={12} sm={12}>
                            <div className={"form-group mb-1 bet-input"}>
                                <div className="input-group">
                                    <div className="input-group-append ">
                                        <span className="input-group-text">
                                          <img
                                              src={"/assets/images/" + this.props.coin + ".png"}
                                              className={"mini-coin-7"}
                                              alt=""
                                          />
                                          BET
                                        </span>
                                    </div>
                                    <input
                                        disabled={inputDisabled2}
                                        type="text"
                                        className="form-control text-left"
                                        id="amount"
                                        name="amount"
                                        placeholder="Enter Bet Amount"
                                        value={this.state.amount}
                                        autoComplete={"off"}
                                        onKeyUp={this.handleInputChange}
                                        onChange={this.handleInputChange}
                                    />
                                    <div className="input-group-append">
                                        <RangeCredit set={this.setAmount} />
                                    </div>
                                </div>
                            </div>
                        </Col> */}

            <div
              className="bet-option game-fonts"
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-around",
                padding: "2px 5px",
                textAlign: "center",
                alignItems: "center",
                justifyItems: "center",
                margin: "0px 4px",
              }}
            >
              {/* manual */}
              <div
                style={{
                  borderRadius: "2rem",
                  padding: "12px 45px",
                  backgroundColor: "#222328",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Manual
              </div>

              {/* auto */}
              {/* <div
                style={{
                  borderRadius: "2rem",
                  padding: "12px 45px",
                  cursor: "pointer",
                  fontSize: "14px",
                  color: "gray",
                }}
              >
                Auto
              </div> */}
            </div>

            <Col xl={12} md={12} sm={12}>
              <div className={"form-group mb-1 bet-input "}>
                <div
                  style={{
                    color: "gray",
                    fontSize: "15px",
                    padding: "2px",
                    marginLeft: "12px",
                    justifyItems: "center",
                    alignItems: "center",
                  }}
                  className="game-fonts"
                >
                  Amount
                  <span
                    style={{
                      padding: "0px 3px",
                      color: "#3d9d0c",
                      fontSize: "15px", // Increase the icon size if needed
                      fontWeight: "bold", // Attempt to bolden icon by scaling
                      //   display: 'inline-flex',
                      alignItems: "center",
                    }}
                  >
                    <FiAlertCircle style={{ strokeWidth: 3 }} />{" "}
                    {/* Increase strokeWidth for a bolder look */}
                  </span>
                </div>

                <div className="input-group" style={{ borderRadius: "2rem " }}>
                  {" "}
                  {/* Rounded border for the input group */}
                  <div className="input-group-append input-radius-left">
                    <span
                      className="input-group-text game-fonts"
                      style={{
                        borderRadius: "2rem 0 0 10px",
                        backgroundColor: "#222328",
                      }}
                    >
                      {" "}
                      {/* Rounded left side of the span */}
                      <img
                        src={"/assets/images/" + this.props.coin + ".png"}
                        className={"mini-coin-7"}
                        alt=""
                      />
                      {/* BET */}
                    </span>
                  </div>
                  <input
                    disabled={inputDisabled2}
                    type="text"
                    className="form-control text-left"
                    id="amount"
                    name="amount"
                    placeholder="Enter Bet Amount"
                    value={this.state.amount}
                    autoComplete={"off"}
                    onKeyUp={this.handleInputChange}
                    onChange={this.handleInputChange}
                    // backgroundColor="#222328"
                    style={{
                      borderRadius: "0 0px 0px 0", // Rounded right side of the input field
                      paddingLeft: "0px", // Optional: Ensure the padding inside the input is well spaced
                      backgroundColor: "#222328",
                    }}
                  />
                  <div
                    className="input-group-append"
                    style={{ display: "flex", gap: "1px" }}
                  >
                    <div
                      className="game-fonts"
                      style={{
                        width: "40px",
                        display: "flex",
                        backgroundColor: "#31343c",
                        alignItems: "center",
                        textAlign: "center",
                        justifyItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      /2
                    </div>
                    <div
                      className="game-fonts"
                      style={{
                        width: "40px",
                        backgroundColor: "#31343c",
                        alignItems: "center",
                        textAlign: "center",
                        display: "flex",
                        justifyItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      x2
                    </div>
                    <RangeCredit set={this.setAmount} />
                  </div>
                </div>
              </div>
            </Col>

            <Col xl={12} md={12} sm={12}>
              <div className={"form-group mb-1"}>
                <div
                  style={{
                    color: "gray",
                    fontSize: "15px",
                    padding: "2px",
                    marginLeft: "12px",
                    justifyItems: "center",
                    alignItems: "center",
                  }}
                  className="game-fonts"
                >
                  Mines
                </div>
                <div className="input-group fw">
                  <div className="input-group-append input-radius-left">
                    <span
                      className="input-group-text game-fonts"
                      style={{ backgroundColor: "#222328" }}
                    >
                      <i className="mdi mdi-bomb font-25 text-danger mr-1" />
                      NUMBER OF MINES
                    </span>
                  </div>
                  <Dropdown
                    drop={""}
                    className={"drop-select btn-block input-radius-right"}
                    style={{ backgroundColor: "#222328" }}
                  >
                    <Dropdown.Toggle split variant="" className={"py-0 mt-0"}>
                      <span className="text-muted text-center">
                        <i className={"mdi mdi-chevron-down mr-1"} /> {mine}
                      </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      disabled={inputDisabled2}
                      className={"dopdown-menu-bottom " + inputDisabled2}
                    >
                      <Dropdown.Item
                        onClick={(e) => this.handleInputMines(3)}
                        className={"animated fadeIn dropdown-item-but"}
                      >
                        3
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={(e) => this.handleInputMines(5)}
                        className={"animated fadeIn dropdown-item-but"}
                      >
                        5
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={(e) => this.handleInputMines(10)}
                        className={"animated fadeIn dropdown-item-but"}
                      >
                        10
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={(e) => this.handleInputMines(24)}
                        className={"animated fadeIn dropdown-item-but"}
                      >
                        24
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12} sm={12} className=" m-auto">
              <div
                className={"form-group rev mt-2 mb-0"}
                style={{ margin: "5px" }}
              >
                <Button
                  variant={"btn btn-md btn-block mt-2 " + this.state.btnType}
                  disabled={inputDisabled}
                  type="submit"
                  style={{
                    // border: "2px solid red",
                    color: "#fff",
                    boxShadow:
                      "0px 0px 12px rgba(35, 238, 136, 0.3), 0px -2px rgb(29, 202, 106) inset",

                    // backgroundColor: "rgb(67, 179, 9)",
                    backgroundImage:
                      "linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113))",
                    borderRadius: "10px",
                  }}
                >
                  {this.state.buttonText}
                </Button>
              </div>
            </Col>

            <div
              className="mines-option game-fonts"
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-around",
                padding: "2px 5px",
                textAlign: "center",
                alignItems: "center",
                justifyItems: "center",
                margin: "0px 0px",
                borderTop: "1px solid #222328",
              }}
            >
              {/* Manual */}
              <div className={`mines-manual-button `}>Manual</div>

              {/* Auto */}
              {/* <div className={`mines-auto-button `}>Auto</div> */}
            </div>
          </Row>
        </form>
      </>
    );
  }
}

Bet.propTypes = {
  coin: PropTypes.string.isRequired,
  credit: PropTypes.string,
};

const mapStateToProps = (state) => ({
  coin: state.items.coin,
  credit: state.items.credit,
});

export default connect(mapStateToProps, {
  gameCoin,
  setWallet,
})(Bet);
